class NSSPDPReviews extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][PDP Reviews] Connected.");
    this.initSlider();
    this.addEventListener("pdpUpdate", this.updateContent.bind(this));
  }

  initSlider() {
    const el = document.querySelector('.nss-pdp-reviews__grid');

    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left + rect.width >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right - rect.width <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    function updateRotate(el) {
      el.querySelectorAll('.nss-pdp-reviews__item').forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        if (isInViewport(item)) {
          const start = parseFloat(item.getAttribute('data-rotate_start'));
          const end = parseFloat(item.getAttribute('data-rotate_end'));
          let newVal =
            start +
            ((end - start) *
              ((100 * (el.clientWidth + 2 * rect.width - rect.left)) / (el.clientWidth + 2 * rect.width) - 40)) /
              100;
          item.style.transform = `rotate(${newVal}deg)`;
        }
      });
    }

    el.addEventListener('scroll', (event) => {
      updateRotate(el);
    });
    el.scrollLeft = 1;
    el.scrollLeft = 0;

    const slider = el;
    let mouseDown = false;
    let startX, scrollLeft;

    let startDragging = function (e) {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (event) {
      mouseDown = false;
    };

    slider.addEventListener('mousemove', (e) => {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    });

    // Add the event listeners
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  }

  updateContent(e) {
    if (this.debug) console.log("[NSS][PDP Reviews] Updating...");
    const variantId = e.detail;
    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`);
    });
    if (this.debug) console.log("[NSS][PDP Reviews] variantId:", variantId);
    const contentEls = this.querySelectorAll(`[nss-variant-id="${variantId}"]`);
    contentEls.forEach((contentEl) => {
      contentEl.classList.add(`nss-active`);
    });

    // Update color scheme
    const prefix = "nss-scheme-";
    const classes = this.className.split(" ").filter(c => !c.startsWith(prefix));
    this.className = classes.join(" ").trim();
    this.classList.add(`nss-scheme-${variantId}`);
  }
}

let elementName = `nss-pdp-reviews`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPDPReviews);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}